import script from "./DailyGoalWheel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DailyGoalWheel.vue?vue&type=script&setup=true&lang=ts"

import "./DailyGoalWheel.vue?vue&type=style&index=0&id=3f6ab01a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f6ab01a"]])

export default __exports__